import { IoLogoWhatsapp } from "react-icons/io5";

const DesktopWa = () => {

  const handleWhatsAppClick = () => {
    // Add your WhatsApp number here
    const phoneNumber = "9980685056";
    const defaultText = encodeURIComponent("Hi, I have gone through your website.Could you provide me more details.");
    // Generate the WhatsApp chat URL
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${defaultText}`;
    // Open the WhatsApp chat link in a new tab
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div>
      <a href="#" onClick={handleWhatsAppClick}>
        <button className="bg-black rounded-full pl-[10px] pr-[10px] pt-[10px] pb-[10px] hover:scale-110" aria-label="whatsapp">
          <IoLogoWhatsapp size={20} className="text-white" />
        </button>
      </a>
    </div>
  );
};

export default DesktopWa;
